import classnames from 'classnames/bind'
import { useRef } from 'react'

// Components
import ProductCard from '@/components/shared/ProductCard'

// Libs
import { ProductRecommendResultType } from '@/api/fetchProductRecommend'
import { useObserver } from '@/hooks/useObserver'
import { handleGtmViewItemList } from '@/methods/handleGtmEvent'
import { RecSource } from '@/methods/recommendTracking'

// Constants
import { GtmItemListName } from '@/constants/gtmEvent'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface IProps {
  title: string
  itemListName: GtmItemListName
  // 推薦區塊：GA 的 item_list_id 是 recommend_{recSource}，點擊時記下來源（推薦成效）
  recSource: RecSource
  items: ProductRecommendResultType['items']
  className?: string
}

// 推薦商品區塊（商品頁、購物車共用）：白底卡片，桌機 6 欄、平板 / 手機 3 欄；第一次出現在畫面上時送一次 view_item_list
const RecommendProductSection = ({ title, itemListName, recSource, items, className }: IProps) => {
  const gtmList = { itemListName, itemListId: `recommend_${recSource}`, useListForItems: true }
  const sentRef = useRef(false)
  const { observerRef } = useObserver({
    observerCallback: (entries) => {
      if (sentRef.current || !entries.some((entry) => entry.isIntersecting)) return
      sentRef.current = true
      handleGtmViewItemList({ ...gtmList, productInfoList: items })
    },
    dep: [items],
  })

  return (
    <div className={cx('recommend-section', className)}>
      <div className={cx('recommend-section__title')}>{title}</div>
      <div className={cx('recommend-section__list')}>
        {items.map((data) => (
          <ProductCard
            key={data.productId}
            className={cx('recommend-section__item')}
            productName={data.productName}
            isPromo
            {...(data as any)}
            isMiniWidth={true}
            observer={observerRef.current}
            gtmItemEventParams={gtmList}
            recSource={recSource}
          />
        ))}
      </div>
    </div>
  )
}

export default RecommendProductSection
